var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-game-loading"},[_c('div',{staticClass:"m-auto text-center"},[_c('b-spinner',{staticClass:"m-auto spinner-main",attrs:{"label":"Loading..."}}),_c('br'),_vm._v(" Please wait... ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }